(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["404"]) return;
  try {
    
  (() => {
    const pupils = document.querySelectorAll('.js-pupil');
    if (!pupils.length) return;

    const maxOffset = 12;
    const lerpFactor = 0.18;
    const basePositions = [];
    const currentPositions = [];
    let mouseX = -1;
    let mouseY = -1;
    let rafId = null;

    pupils.forEach((pupil) => {
      const cx = parseFloat(pupil.getAttribute('cx'));
      const cy = parseFloat(pupil.getAttribute('cy'));
      basePositions.push({ cx, cy });
      currentPositions.push({ cx, cy });
      pupil.setAttribute('cx', cx);
      pupil.setAttribute('cy', cy);
    });

    const svg = pupils[0].closest('svg');

    const lerp = (a, b, t) => a + (b - a) * t;

    const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

    const onPointerMove = (event) => {
      mouseX = event.clientX ?? event.touches?.[0]?.clientX ?? mouseX;
      mouseY = event.clientY ?? event.touches?.[0]?.clientY ?? mouseY;
    };

    const animate = () => {
      if (mouseX < 0 || mouseY < 0) {
        rafId = requestAnimationFrame(animate);
        return;
      }

      const rect = svg.getBoundingClientRect();

      pupils.forEach((pupil, index) => {
        const base = basePositions[index];
        const curr = currentPositions[index];

        const absCenterX = rect.left + (base.cx / 200) * rect.width;
        const absCenterY = rect.top + (base.cy / 160) * rect.height;

        const deltaX = mouseX - absCenterX;
        const deltaY = mouseY - absCenterY;
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        const angle = Math.atan2(deltaY, deltaX);

        const scaledDistance = clamp(distance / 50, 0, maxOffset);
        const targetX = Math.cos(angle) * scaledDistance;
        const targetY = Math.sin(angle) * scaledDistance;

        curr.cx = lerp(curr.cx, base.cx + targetX, lerpFactor);
        curr.cy = lerp(curr.cy, base.cy + targetY, lerpFactor);

        pupil.setAttribute('cx', curr.cx);
        pupil.setAttribute('cy', curr.cy);
      });

      rafId = requestAnimationFrame(animate);
    };

    window.addEventListener('pointermove', onPointerMove, { passive: true });
    rafId = requestAnimationFrame(animate);

    const cleanup = () => {
      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
    };

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:unload', cleanup);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-diziana"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const ensureScrollTriggerRegistered = () => {
      if (!window.gsap || !window.ScrollTrigger) {
        return false;
      }

      window.__themeGsap = window.__themeGsap || {};

      if (!window.__themeGsap.scrollTriggerRegistered) {
        window.gsap.registerPlugin(window.ScrollTrigger);
        window.__themeGsap.scrollTriggerRegistered = true;
      }

      return true;
    };

    const initAboutAnimations = () => {
      const aboutPage = document.querySelector('.about-page');

      if (!aboutPage || prefersReducedMotion || !ensureScrollTriggerRegistered()) {
        return;
      }

      const animatedNodes = aboutPage.querySelectorAll(
        '.about-page__hero, .about-page__leadership, .about-page__capabilities, .about-page__roles, .about-page__cta-band'
      );

      window.gsap.fromTo(
        animatedNodes,
        { y: 28, autoAlpha: 0 },
        {
          y: 0,
          autoAlpha: 1,
          duration: 0.8,
          ease: 'power3.out',
          stagger: 0.08,
          clearProps: 'transform,opacity,visibility',
          scrollTrigger: {
            trigger: aboutPage,
            start: 'top 78%',
            once: true,
            toggleActions: 'play none none none',
          },
        }
      );
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAboutAnimations, { once: true });
    } else {
      initAboutAnimations();
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.querySelector('.about-page')) {
        initAboutAnimations();

        if (window.ScrollTrigger) {
          requestAnimationFrame(() => window.ScrollTrigger.refresh());
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article"]) return;
  try {
    
  (() => {
    const initScrollReveal = () => {
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReducedMotion) return;

      const elements = document.querySelectorAll(
        '.article-page__related-card, .article-page__recent-item, .article-page__comment'
      );
      if (!window.IntersectionObserver || elements.length === 0) return;

      elements.forEach((el) => {
        el.style.opacity = '0';
        el.style.transform = 'translateY(20px)';
        el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      });

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.style.opacity = '1';
              entry.target.style.transform = 'translateY(0)';
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1, rootMargin: '0px 0px -30px 0px' }
      );

      elements.forEach((el) => observer.observe(el));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initScrollReveal, { once: true });
    } else {
      initScrollReveal();
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.querySelector('.article-page')) {
        initScrollReveal();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initScrollReveal = () => {
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReducedMotion) return;

      const cards = document.querySelectorAll('.blog-grid__card');
      if (!window.IntersectionObserver || cards.length === 0) return;

      cards.forEach((card) => {
        card.style.opacity = '0';
        card.style.transform = 'translateY(24px)';
        card.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      });

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.style.opacity = '1';
              entry.target.style.transform = 'translateY(0)';
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
      );

      cards.forEach((card) => observer.observe(card));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initScrollReveal, { once: true });
    } else {
      initScrollReveal();
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.querySelector('.blog-grid')) {
        initScrollReveal();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog"]) return;
  try {
    
  (() => {
    const initScrollReveal = () => {
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReducedMotion) return;

      const cards = document.querySelectorAll('.blog-page__card');
      if (!window.IntersectionObserver || cards.length === 0) return;

      cards.forEach((card) => {
        card.style.opacity = '0';
        card.style.transform = 'translateY(24px)';
        card.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      });

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.style.opacity = '1';
              entry.target.style.transform = 'translateY(0)';
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
      );

      cards.forEach((card) => observer.observe(card));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initScrollReveal, { once: true });
    } else {
      initScrollReveal();
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.querySelector('.blog-page')) {
        initScrollReveal();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["byod-customers"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const initializedSections = new WeakSet();

    const ensureScrollTriggerRegistered = () => {
      if (!window.gsap || !window.ScrollTrigger) {
        return false;
      }

      window.__themeGsap = window.__themeGsap || {};

      if (!window.__themeGsap.scrollTriggerRegistered) {
        window.gsap.registerPlugin(window.ScrollTrigger);
        window.__themeGsap.scrollTriggerRegistered = true;
      }

      return true;
    };

    const revealSection = (sectionNode) => {
      sectionNode.classList.add('byod-customers--animate');
    };

    const initSection = (sectionNode) => {
      if (!sectionNode || initializedSections.has(sectionNode)) {
        return;
      }

      initializedSections.add(sectionNode);

      if (prefersReducedMotion || !ensureScrollTriggerRegistered()) {
        revealSection(sectionNode);
        return;
      }

      window.ScrollTrigger.create({
        trigger: sectionNode,
        start: 'top 72%',
        once: true,
        onEnter: () => {
          revealSection(sectionNode);
        },
      });
    };

    const initSections = (scope) => {
      if (!scope) {
        return;
      }

      if (scope.matches && scope.matches('.byod-customers')) {
        initSection(scope);
      }

      scope.querySelectorAll('.byod-customers').forEach((sectionNode) => {
        initSection(sectionNode);
      });
    };

    const runInit = () => {
      initSections(document);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runInit, { once: true });
    } else {
      runInit();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initSections(event.target);

      if (window.ScrollTrigger) {
        requestAnimationFrame(() => {
          window.ScrollTrigger.refresh();
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["byod-promotions"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const ensureScrollTriggerRegistered = () => {
      if (!window.gsap || !window.ScrollTrigger) return false;
      window.__themeGsap = window.__themeGsap || {};
      if (!window.__themeGsap.scrollTriggerRegistered) {
        window.gsap.registerPlugin(window.ScrollTrigger);
        window.__themeGsap.scrollTriggerRegistered = true;
      }
      return true;
    };

    const initByodAnimations = () => {
      const byodPage = document.querySelector('.byod-promotions');
      if (!byodPage || prefersReducedMotion || !ensureScrollTriggerRegistered()) return;

      const steps = document.querySelectorAll('.byod-promotions__step');
      if (steps.length === 0) return;

      window.gsap.fromTo(
        steps,
        { y: 20, autoAlpha: 0 },
        {
          y: 0,
          autoAlpha: 1,
          duration: 0.5,
          ease: 'power2.out',
          stagger: 0.06,
          clearProps: 'transform,opacity,visibility',
          scrollTrigger: {
            trigger: byodPage,
            start: 'top 75%',
            once: true,
            toggleActions: 'play none none none',
          },
        }
      );
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initByodAnimations, { once: true });
    } else {
      initByodAnimations();
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.querySelector('.byod-promotions')) {
        initByodAnimations();
        if (window.ScrollTrigger) {
          requestAnimationFrame(() => window.ScrollTrigger.refresh());
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["careers"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initCopyEmail = (section) => {
      const applyBtns = section.querySelectorAll('.careers__job-apply--copy');
      if (applyBtns.length === 0) return;

      applyBtns.forEach((btn) => {
        btn.addEventListener('click', async () => {
          const email = btn.dataset.email;
          if (!email) return;

          const tooltip = btn.querySelector('.careers__job-apply-tooltip');
          const originalText = tooltip.textContent;
          const copiedIcon = btn.dataset.tooltipCopiedIcon || 'ph-check-fat';
          const copiedText = btn.dataset.tooltipCopiedText || 'Email copied to clipboard';

          try {
            await navigator.clipboard.writeText(email);
            btn.classList.add('copied');
            tooltip.innerHTML = '<i class="ph-bold ' + copiedIcon + '"></i> ' + copiedText;
            setTimeout(() => {
              btn.classList.remove('copied');
              tooltip.textContent = originalText;
            }, 2000);
          } catch (err) {
            const textarea = document.createElement('textarea');
            textarea.value = email;
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
            btn.classList.add('copied');
            tooltip.innerHTML = '<i class="ph-bold ' + copiedIcon + '"></i> ' + copiedText;
            setTimeout(() => {
              btn.classList.remove('copied');
              tooltip.textContent = originalText;
            }, 2000);
          }
        });
      });
    };

    const initJobFilters = (section) => {
      const filterBar = section.querySelector('.careers__filter-bar');
      const jobsList = section.querySelector('.careers__jobs-list');
      if (!filterBar || !jobsList) return;

      const filterBtns = filterBar.querySelectorAll('.careers__filter-btn');
      const jobRows = jobsList.querySelectorAll('.careers__job-row');

      filterBar.addEventListener('click', (e) => {
        const btn = e.target.closest('.careers__filter-btn');
        if (!btn) return;

        filterBtns.forEach((b) => b.classList.remove('careers__filter-btn--active'));
        btn.classList.add('careers__filter-btn--active');

        const cat = btn.dataset.cat;

        jobRows.forEach((row) => {
          if (cat === 'all' || row.dataset.category === cat) {
            row.style.display = '';
          } else {
            row.style.display = 'none';
          }
        });
      });
    };

    const initScrollReveal = (section) => {
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReducedMotion) return;

      const elements = section.querySelectorAll(
        '.careers__benefit-card, .careers__value-item, .careers__job-row'
      );

      if (!window.IntersectionObserver) return;

      elements.forEach((el) => {
        el.style.opacity = '0';
        el.style.transform = 'translateY(20px)';
        el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      });

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.style.opacity = '1';
              entry.target.style.transform = 'translateY(0)';
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1 }
      );

      elements.forEach((el) => observer.observe(el));
    };

    const init = () => {
      const sections = document.querySelectorAll('.careers');
      sections.forEach((section) => {
        initCopyEmail(section);
        initJobFilters(section);
        initScrollReveal(section);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.careers');
      if (section) {
        initCopyEmail(section);
        initJobFilters(section);
        initScrollReveal(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('cart-form');
    if (!form) return;

    const qtyInputs = form.querySelectorAll('.cart-item__qty-input');
    const qtyBtns = form.querySelectorAll('.cart-item__qty-btn');
    const removeBtns = form.querySelectorAll('.cart-item__btn--remove');

    function updateCart(line, quantity) {
      const cartItem = form.querySelector(`.cart-item[data-line="${line}"]`);
      if (cartItem) {
        cartItem.classList.add('cart-item--loading');
      }

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          line: line,
          quantity: quantity
        })
      })
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        if (cart.item_count === 0) {
          window.location.reload();
          return;
        }

        if (quantity === 0) {
          if (cartItem) {
            cartItem.remove();
          }
        } else {
          const input = form.querySelector(`.cart-item__qty-input[data-line="${line}"]`);
          if (input) {
            input.value = quantity;
          }

          const lineItem = cart.items.find(function(item) {
            return item.key === cartItem?.dataset.key;
          });

          if (lineItem && cartItem) {
            const priceContainer = cartItem.querySelector('.cart-item__pricing');
            if (priceContainer) {
              const hasDiscount = lineItem.original_line_price > lineItem.final_line_price;
              const currency = typeof cart.currency === 'string' ? cart.currency : cart.currency?.iso_code;
              priceContainer.innerHTML = '';

              if (hasDiscount) {
                const salePrice = document.createElement('span');
                salePrice.className = 'cart-item__price cart-item__price--sale';
                salePrice.textContent = formatMoney(lineItem.final_line_price, currency);
                priceContainer.appendChild(salePrice);

                const originalPrice = document.createElement('span');
                originalPrice.className = 'cart-item__price cart-item__price--original';
                originalPrice.textContent = formatMoney(lineItem.original_line_price, currency);
                priceContainer.appendChild(originalPrice);
              } else {
                const price = document.createElement('span');
                price.className = 'cart-item__price';
                price.textContent = formatMoney(lineItem.final_line_price, currency);
                priceContainer.appendChild(price);
              }
            }
          }
        }

        updateCartTotals(cart);
      })
      .catch(function(error) {
        console.error('Error updating cart:', error);
        if (cartItem) {
          cartItem.classList.remove('cart-item--loading');
        }
      });
    }

    function updateCartTotals(cart) {
      if (!cart || !cart.currency) return;
      const totalEl = document.querySelector('[data-cart-total]');
      const discountEl = document.querySelector('[data-subtotal-discount]');
      const currency = typeof cart.currency === 'string' ? cart.currency : cart.currency?.iso_code;

      if (totalEl) {
        totalEl.textContent = formatMoney(cart.total_price, currency);
      }

      if (discountEl && cart.total_discount > 0) {
        discountEl.textContent = '-' + formatMoney(cart.total_discount, currency);
      }
    }

    function formatMoney(cents, currency) {
      if (!currency || cents === undefined || cents === null) return '';
      const amount = (Number(cents) / 100).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      return currency + ' ' + amount;
    }

    qtyBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        const line = parseInt(this.dataset.line);
        const action = this.dataset.action;
        const input = form.querySelector(`.cart-item__qty-input[data-line="${line}"]`);
        const currentQty = parseInt(input.value) || 1;
        let newQty;

        if (action === 'increase') {
          newQty = currentQty + 1;
        } else if (action === 'decrease') {
          newQty = currentQty > 1 ? currentQty - 1 : 0;
        }

        if (newQty !== undefined) {
          updateCart(line, newQty);
        }
      });
    });

    removeBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        const line = parseInt(this.dataset.line);
        updateCart(line, 0);
      });
    });

    qtyInputs.forEach(function(input) {
      let timeout;
      input.addEventListener('change', function() {
        clearTimeout(timeout);
        const line = parseInt(this.dataset.line);
        const newQty = parseInt(this.value) || 0;
        timeout = setTimeout(function() {
          updateCart(line, newQty);
        }, 500);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const scrollTargetId = new URLSearchParams(window.location.search).get('scroll');
    if (scrollTargetId) {
      const targetElement = document.getElementById(scrollTargetId);
      if (targetElement instanceof HTMLElement) {
        setTimeout(() => {
          targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 300);
      }
    }

    document.querySelectorAll('.collection-premium__hero-cta').forEach((link) => {
      if (!(link instanceof HTMLAnchorElement)) return;

      link.addEventListener('click', (event) => {
        const targetUrl = new URL(link.href, window.location.origin);
        const targetHash = targetUrl.hash ? decodeURIComponent(targetUrl.hash.slice(1)) : '';
        const requestedScroll = targetUrl.searchParams.get('scroll');
        const targetId = requestedScroll || targetHash;

        if (!targetId) return;

        const targetElement = document.getElementById(targetId);
        if (!(targetElement instanceof HTMLElement)) return;

        event.preventDefault();
        history.replaceState(null, '', targetUrl.toString());
        targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    const initScrollReveal = () => {
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReducedMotion) return;

      const cards = document.querySelectorAll('.collection-premium__card');
      if (!window.IntersectionObserver || cards.length === 0) return;

      cards.forEach((card) => {
        card.style.opacity = '0';
        card.style.transform = 'translateY(24px)';
        card.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      });

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.style.opacity = '1';
              entry.target.style.transform = 'translateY(0)';
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
      );

      cards.forEach((card) => observer.observe(card));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initScrollReveal();
        initThemeShowcase();
      }, { once: true });
    } else {
      initScrollReveal();
      initThemeShowcase();
    }

    const filterSelect = document.querySelector('.collection-premium__filter-select');
    if (filterSelect) {
      const cards = document.querySelectorAll('.collection-premium__card');
      const emptyState = document.querySelector('.collection-premium__empty');

      filterSelect.addEventListener('change', function() {
        const selectedTag = this.value;
        let visibleCount = 0;

        cards.forEach((card) => {
          const cardTags = card.dataset.tags || '';
          const shouldShow = !selectedTag || cardTags.includes(selectedTag);
          card.style.display = shouldShow ? '' : 'none';
          if (shouldShow) visibleCount++;
        });

        if (emptyState) {
          emptyState.style.display = visibleCount === 0 ? '' : 'none';
        }
      });
    }

    /* ── THEME SHOWCASE JS ── */
    function initThemeShowcase() {
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const initializedSections = new WeakSet();

      const ensureGSAPReady = () => {
        if (!window.gsap) return false;
        if (!window.__themeGsap) window.__themeGsap = {};
        if (!window.__themeGsap.scrollTriggerRegistered) {
          window.gsap.registerPlugin(window.ScrollTrigger);
          window.__themeGsap.scrollTriggerRegistered = true;
        }
        return true;
      };

      const initHoverScroll = (sectionNode) => {
        const scrollContainers = sectionNode.querySelectorAll('[data-scroll-image]');

        scrollContainers.forEach((container) => {
          const img = container.querySelector('.theme-showcase__image');
          if (!img) return;

          let scrollTween = null;
          const speed = 1.2;

          container.addEventListener('mouseenter', () => {
            const parent = container.parentElement;
            const containerH = parent.clientHeight;
            const imgH = img.clientHeight;

            if (imgH <= containerH) return;

            const maxScroll = imgH - containerH;
            const duration = maxScroll / (speed * 100);

            scrollTween = window.gsap.to(container, {
              y: -maxScroll,
              duration: duration,
              ease: 'none',
              overwrite: true,
            });
          });

          container.addEventListener('mouseleave', () => {
            if (scrollTween) {
              scrollTween.kill();
              scrollTween = null;
            }

            window.gsap.to(container, {
              y: 0,
              duration: 0.9,
              ease: 'power2.out',
              overwrite: true,
            });
          });
        });
      };

      const initScrollTriggerReveal = (sectionNode) => {
        if (prefersReducedMotion || !ensureGSAPReady()) return;

        const headerNode = sectionNode.querySelector('.theme-showcase__header');
        const boxNode = sectionNode.querySelector('.theme-showcase__box');
        const tickerNodes = sectionNode.querySelectorAll('.theme-showcase__ticker');

        if (!headerNode || !boxNode) return;

        window.gsap.set([headerNode, boxNode], {
          y: 28,
          autoAlpha: 0,
        });

        if (tickerNodes.length) {
          window.gsap.set(tickerNodes, {
            y: 20,
            autoAlpha: 0,
          });
        }

        const vectorPath = sectionNode.querySelector('.theme-showcase__zendesk-vector-path');
        if (vectorPath) {
          window.gsap.set(vectorPath, {
            strokeDasharray: vectorPath.getTotalLength(),
            strokeDashoffset: vectorPath.getTotalLength(),
          });
        }

        const timeline = window.gsap.timeline({
          scrollTrigger: {
            trigger: sectionNode,
            start: 'top 78%',
            once: true,
            toggleActions: 'play none none none',
          },
        });

        timeline.to(headerNode, {
          y: 0,
          autoAlpha: 1,
          duration: 0.92,
          ease: 'power3.out',
          clearProps: 'transform,opacity,visibility',
        });

        timeline.to(
          boxNode,
          {
            y: 0,
            autoAlpha: 1,
            duration: 0.92,
            ease: 'power3.out',
            clearProps: 'transform,opacity,visibility',
          },
          '<0.32'
        );

        if (vectorPath) {
          timeline.add(() => {
            vectorPath.classList.add('is-animated');
          }, '<0.32');
        }

        if (tickerNodes.length) {
          timeline.to(
            tickerNodes[0],
            {
              y: 0,
              autoAlpha: 1,
              duration: 0.72,
              ease: 'power3.out',
              clearProps: 'transform,opacity,visibility',
            },
            '<0.28'
          );

          if (tickerNodes[1]) {
            timeline.to(
              tickerNodes[1],
              {
                y: 0,
                autoAlpha: 1,
                duration: 0.72,
                ease: 'power3.out',
                clearProps: 'transform,opacity,visibility',
              },
              '<0.18'
            );
          }
        }
      };

      const initSection = (sectionNode) => {
        if (!sectionNode || initializedSections.has(sectionNode)) return;
        initializedSections.add(sectionNode);

        initHoverScroll(sectionNode);
        initScrollTriggerReveal(sectionNode);
        initTicker(sectionNode);
      };

      const initTicker = (sectionNode) => {
        if (prefersReducedMotion) return;
        if (!window.gsap) return;

        const tickers = sectionNode.querySelectorAll('.theme-showcase__ticker');

        tickers.forEach(function (ticker) {
          const tracks = ticker.querySelectorAll('.theme-showcase__ticker-track');
          if (!tracks.length) return;

          const track = tracks[0];
          const gap = parseFloat(getComputedStyle(track).gap) || 56;
          const singleTrackWidth = track.offsetWidth + gap;

          if (singleTrackWidth <= 0) return;

          const isReverse = ticker.classList.contains('theme-showcase__ticker--reverse');
          const pixelsPerSecond = 40;
          const duration = singleTrackWidth / pixelsPerSecond;

          let scrollTween;
          if (isReverse) {
            window.gsap.set(tracks, { x: -singleTrackWidth });
            scrollTween = window.gsap.to(tracks, {
              x: 0,
              duration: duration,
              ease: 'none',
              repeat: -1,
              overwrite: true,
            });
          } else {
            scrollTween = window.gsap.to(tracks, {
              x: -singleTrackWidth,
              duration: duration,
              ease: 'none',
              repeat: -1,
            });
          }

          ticker.addEventListener('mouseenter', function () {
            scrollTween.pause();
          });

          ticker.addEventListener('mouseleave', function () {
            scrollTween.play();
          });
        });
      };

      const initSections = (scope) => {
        if (!scope) return;
        if (scope.matches && scope.matches('.theme-showcase')) {
          initSection(scope);
        }
        scope.querySelectorAll('.theme-showcase').forEach(initSection);
      };

      initSections(document);

      document.addEventListener('shopify:section:load', (event) => {
        initSections(event.target);
        if (window.ScrollTrigger) {
          requestAnimationFrame(() => window.ScrollTrigger.refresh());
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-us"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const widgetTrigger = document.getElementById('contact-widget-trigger');
    if (widgetTrigger) {
      let widgetOpen = false;
      let listenersAttached = false;

      function attachWidgetListeners() {
        if (typeof zE !== 'function' || listenersAttached) return;
        listenersAttached = true;
        zE('messenger:on', 'open', function () { widgetOpen = true; });
        zE('messenger:on', 'close', function () { widgetOpen = false; });
      }

      const checkZe = setInterval(function () {
        if (typeof zE === 'function') {
          clearInterval(checkZe);
          attachWidgetListeners();
        }
      }, 100);

      widgetTrigger.addEventListener('click', function () {
        if (typeof zE !== 'function') return;
        if (widgetOpen) {
          zE('messenger', 'close');
        } else {
          zE('messenger', 'open');
        }
      });
    }

    const phoneInput = document.getElementById('contact-phone');

    const scheduleToggle = document.getElementById('contact-schedule-toggle');
    const schedulePanel = document.getElementById('contact-schedule-panel');
    const dateInput = document.getElementById('contact-date');
    const timeInput = document.getElementById('contact-time');
    const phoneStar = document.getElementById('phone-required-star');
    const dateStar = document.getElementById('contact-date-required-star');
    const timeStar = document.getElementById('contact-time-required-star');
    const tzStar = document.getElementById('contact-timezone-required-star');
    const orgStar = document.getElementById('org-required-star');
    const orgInput = document.getElementById('contact-organization');

    if (scheduleToggle && schedulePanel) {
      scheduleToggle.addEventListener('change', function () {
        if (scheduleToggle.checked) {
          schedulePanel.classList.add('contact-us__schedule-panel--open');
          if (phoneStar) phoneStar.style.display = 'inline';
          if (dateStar) dateStar.style.display = 'inline';
          if (timeStar) timeStar.style.display = 'inline';
          if (tzStar) tzStar.style.display = 'inline';
          if (orgStar) orgStar.style.display = 'inline';
          if (phoneInput) phoneInput.setAttribute('required', 'required');
          if (dateInput) dateInput.setAttribute('required', 'required');
          if (timeInput) timeInput.setAttribute('required', 'required');
          if (orgInput) orgInput.setAttribute('required', 'required');
        } else {
          schedulePanel.classList.remove('contact-us__schedule-panel--open');
          if (phoneStar) phoneStar.style.display = 'none';
          if (dateStar) dateStar.style.display = 'none';
          if (timeStar) timeStar.style.display = 'none';
          if (tzStar) tzStar.style.display = 'none';
          if (orgStar) orgStar.style.display = 'none';
          if (phoneInput) phoneInput.removeAttribute('required');
          if (dateInput) dateInput.removeAttribute('required');
          if (timeInput) timeInput.removeAttribute('required');
          if (orgInput) orgInput.removeAttribute('required');
        }
      });

      const scheduleSearchParams = new URLSearchParams(window.location.search);
      if (scheduleSearchParams.has('schedule') && !scheduleToggle.checked) {
        scheduleToggle.checked = true;
        scheduleToggle.dispatchEvent(new Event('change'));
      }
    }

    if (dateInput) {
      const today = new Date();
      const yyyy = today.getFullYear();
      const mm = String(today.getMonth() + 1).padStart(2, '0');
      const dd = String(today.getDate()).padStart(2, '0');
      dateInput.setAttribute('min', yyyy + '-' + mm + '-' + dd);
    }

    // --- Timezone selector ---
    (function() {
      var tzTrigger = document.getElementById('contact-tz-trigger');
      var tzDropdown = document.getElementById('contact-tz-dropdown');
      var tzSearch = document.getElementById('contact-tz-search');
      var tzList = document.getElementById('contact-tz-list');
      var tzName = document.getElementById('contact-tz-name');
      var tzAbbr = document.getElementById('contact-tz-abbr');
      var tzCaret = document.getElementById('contact-tz-caret');
      var tzHidden = document.getElementById('contact-timezone');
      if (!tzTrigger || !tzDropdown) return;

      var allTimezones = [];
      var selectedTimezone = '';

      function getTzOffset(tz) {
        var now = new Date();
        var utcStr = now.toLocaleString('en', { timeZone: 'UTC' });
        var tzStr = now.toLocaleString('en', { timeZone: tz });
        var diff = new Date(tzStr) - new Date(utcStr);
        var offsetMin = diff / 60000;
        var sign = offsetMin >= 0 ? '+' : '-';
        var absMin = Math.abs(offsetMin);
        var h = Math.floor(absMin / 60);
        var m = Math.floor(absMin % 60);
        return sign + String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0');
      }

      function getTzDisplay(tz) {
        var parts = Intl.DateTimeFormat('en', { timeZone: tz, timeZoneName: 'short' }).formatToParts(new Date());
        var abbr = (parts.find(function(p) { return p.type === 'timeZoneName'; }) || {}).value || '';
        var offset = getTzOffset(tz);
        return /^GMT[+-]?\d/.test(abbr) ? 'GMT' + offset : abbr + ' ' + offset;
      }

      function buildList() {
        allTimezones = Intl.supportedValuesOf('timeZone').map(function(tz) {
          return {
            tz: tz,
            display: getTzDisplay(tz),
            search: (tz + ' ' + getTzDisplay(tz)).toLowerCase()
          };
        });
      }

      function renderList(filter) {
        tzList.innerHTML = '';
        var items = filter ? allTimezones.filter(function(o) { return o.search.includes(filter.toLowerCase()); }) : allTimezones;
        items.forEach(function(o) {
          var div = document.createElement('div');
          div.className = 'contact-us__tz-option' + (o.tz === selectedTimezone ? ' contact-us__tz-option--selected' : '');
          div.innerHTML = '<span>' + o.tz + '</span><span class="contact-us__tz-offset">' + o.display + '</span>';
          div.addEventListener('click', function() { selectTz(o.tz); });
          tzList.appendChild(div);
        });
      }

      function selectTz(tz) {
        selectedTimezone = tz;
        tzName.textContent = tz;
        tzAbbr.textContent = getTzDisplay(tz);
        tzAbbr.className = 'contact-us__tz-abbr contact-us__tz-abbr--manual';
        if (tzHidden) tzHidden.value = tz;
        closeDropdown();
      }

      function openDropdown() {
        tzDropdown.classList.add('contact-us__tz-dropdown--open');
        tzTrigger.classList.add('contact-us__tz-trigger--open');
        tzCaret.classList.add('contact-us__tz-caret--open');
        renderList('');
        tzSearch.value = '';
        if (tzSearch) {
          try {
            tzSearch.focus({ preventScroll: true });
          } catch (error) {
            tzSearch.focus();
          }
        }
        setTimeout(function() {
          var sel = tzList.querySelector('.contact-us__tz-option--selected');
          if (!sel || !tzList) return;

          var optionTop = sel.offsetTop;
          var optionHeight = sel.offsetHeight;
          var listHeight = tzList.clientHeight;
          tzList.scrollTop = optionTop - ((listHeight - optionHeight) / 2);
        }, 50);
      }

      function closeDropdown() {
        tzDropdown.classList.remove('contact-us__tz-dropdown--open');
        tzTrigger.classList.remove('contact-us__tz-trigger--open');
        tzCaret.classList.remove('contact-us__tz-caret--open');
      }

      tzTrigger.addEventListener('click', function(e) {
        e.stopPropagation();
        if (tzDropdown.classList.contains('contact-us__tz-dropdown--open')) {
          closeDropdown();
        } else {
          openDropdown();
        }
      });

      if (tzSearch) {
        tzSearch.addEventListener('input', function() { renderList(this.value); });
      }

      document.addEventListener('click', function(e) {
        var wrapper = document.getElementById('contact-tz-combo');
        if (wrapper && !wrapper.contains(e.target)) closeDropdown();
      });

      buildList();
      var detected = Intl.DateTimeFormat().resolvedOptions().timeZone;
      selectedTimezone = detected;
      tzName.textContent = detected;
      tzAbbr.textContent = getTzDisplay(detected);
      tzAbbr.className = 'contact-us__tz-abbr contact-us__tz-abbr--auto';
      if (tzHidden) tzHidden.value = detected;
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diziana-aivantage"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var statsWrap = document.querySelector('.aivantage-gen2__stats-wrap');
    if (!statsWrap || !window.gsap) return;

    var tracks = statsWrap.querySelectorAll('.aivantage-gen2__stats-track');
    if (!tracks.length) return;

    var gap = parseFloat(getComputedStyle(statsWrap).gap) || 32;
    var singleTrackWidth = tracks[0].offsetWidth + gap;
    var pixelsPerSecond = 30;
    var duration = singleTrackWidth / pixelsPerSecond;

    var scrollTween = window.gsap.to(tracks, {
      x: -singleTrackWidth,
      duration: duration,
      ease: 'none',
      repeat: -1,
    });

    statsWrap.addEventListener('mouseenter', function() { scrollTween.pause(); });
    statsWrap.addEventListener('mouseleave', function() { scrollTween.play(); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diziana-learn-more"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const ensureScrollTriggerRegistered = () => {
      if (!window.gsap || !window.ScrollTrigger) return false;
      window.__themeGsap = window.__themeGsap || {};
      if (!window.__themeGsap.scrollTriggerRegistered) {
        window.gsap.registerPlugin(window.ScrollTrigger);
        window.__themeGsap.scrollTriggerRegistered = true;
      }
      return true;
    };

    const initAnimations = () => {
      const page = document.querySelector('.diziana-learn-more');
      if (!page || prefersReducedMotion || !ensureScrollTriggerRegistered()) return;

      const cards = page.querySelectorAll('.diziana-learn-more__card');

      window.gsap.fromTo(
        cards,
        { y: 40, autoAlpha: 0 },
        {
          y: 0,
          autoAlpha: 1,
          duration: 0.7,
          ease: 'power3.out',
          stagger: 0.1,
          clearProps: 'transform,opacity,visibility',
          scrollTrigger: {
            trigger: page,
            start: 'top 80%',
            once: true,
            toggleActions: 'play none none none',
          },
        }
      );
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAnimations, { once: true });
    } else {
      initAnimations();
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.querySelector('.diziana-learn-more')) {
        initAnimations();
        if (window.ScrollTrigger) {
          requestAnimationFrame(() => window.ScrollTrigger.refresh());
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const ensureScrollTriggerRegistered = () => {
      if (!window.gsap || !window.ScrollTrigger) {
        return false;
      }

      window.__themeGsap = window.__themeGsap || {};

      if (!window.__themeGsap.scrollTriggerRegistered) {
        window.gsap.registerPlugin(window.ScrollTrigger);
        window.__themeGsap.scrollTriggerRegistered = true;
      }

      return true;
    };

    const initCopyEmail = () => {
      const emailBtn = document.querySelector('.diziana-footer__contact-email');
      if (!emailBtn) return;

      emailBtn.addEventListener('click', async () => {
        const email = emailBtn.dataset.email;
        if (!email) return;

        const originalText = emailBtn.textContent;

        try {
          await navigator.clipboard.writeText(email);
          emailBtn.textContent = 'Copied';

          setTimeout(() => {
            emailBtn.textContent = originalText;
          }, 2000);
        } catch (err) {
          emailBtn.textContent = 'Failed to copy';

          setTimeout(() => {
            emailBtn.textContent = originalText;
          }, 2000);
        }
      });
    };

    const initCopyrightYear = () => {
      const yearEl = document.querySelector('.diziana-footer__year');
      if (yearEl) {
        yearEl.textContent = new Date().getFullYear();
      }
    };

    const initEncryptedTextEffect = () => {
      const trustEl = document.querySelector('.diziana-footer__trust-text');
      if (!trustEl) {
        return;
      }

      const originalText = trustEl.dataset.text || trustEl.textContent;
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+-=[]{}|;:,.<>?';

      // Split text into character spans
      trustEl.innerHTML = '';
      const charSpans = [];
      for (let i = 0; i < originalText.length; i++) {
        const span = document.createElement('span');
        span.classList.add('char');
        span.textContent = originalText[i] === ' ' ? '\u00A0' : originalText[i];
        trustEl.appendChild(span);
        charSpans.push({ span, original: originalText[i] });
      }

      let isAnimating = false;

      // Scramble animation function
      const scrambleEffect = (duration = 1.2) => {
        if (isAnimating) return;
        isAnimating = true;

        // Reset all to scrambled
        charSpans.forEach(({ span, original }) => {
          if (original !== ' ') {
            span.textContent = chars[Math.floor(Math.random() * chars.length)];
            span.classList.remove('revealed');
          }
        });

        // Reveal one by one
        charSpans.forEach(({ span, original }, index) => {
          if (original === ' ') return;

          const delay = (index / charSpans.length) * duration * 1000;
          setTimeout(() => {
            let scrambleTime = 0;
            const scrambleInterval = setInterval(() => {
              scrambleTime += 40;
              if (scrambleTime >= 300) {
                span.textContent = original;
                span.classList.add('revealed');
                clearInterval(scrambleInterval);
                if (index === charSpans.length - 1) {
                  isAnimating = false;
                }
              } else {
                span.textContent = chars[Math.floor(Math.random() * chars.length)];
              }
            }, 40);
          }, delay);
        });
      };

      // Trigger on hover
      trustEl.addEventListener('mouseenter', () => scrambleEffect(1.2));

      // Trigger on scroll if GSAP available
      if (window.gsap && window.ScrollTrigger && !prefersReducedMotion) {
        window.gsap.to({}, {
          duration: 0.01,
          scrollTrigger: {
            trigger: trustEl,
            start: 'top 85%',
            once: true,
            onEnter: () => scrambleEffect(1.2),
          },
        });
      } else {
        // Fallback: run immediately
        setTimeout(() => scrambleEffect(1.2), 800);
      }
    };

    const initFooterAnimation = () => {
      const footer = document.querySelector('.diziana-footer');
      if (!footer || prefersReducedMotion || !ensureScrollTriggerRegistered()) {
        return;
      }

      const elements = [
        '.diziana-footer__brand',
        '.diziana-footer__contact',
        '.diziana-footer__trust-text',
        '.diziana-footer__nav',
        '.diziana-footer__separator',
        '.diziana-footer__bottom',
      ];

      window.gsap.fromTo(
        elements,
        {
          y: 30,
          autoAlpha: 0,
        },
        {
          y: 0,
          autoAlpha: 1,
          duration: 0.96,
          ease: 'power3.out',
          stagger: 0.095,
          clearProps: 'transform,opacity,visibility',
          scrollTrigger: {
            trigger: footer,
            start: 'top 85%',
            once: true,
            toggleActions: 'play none none none',
          },
        }
      );
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          initCopyEmail();
          initCopyrightYear();
          initEncryptedTextEffect();
          initFooterAnimation();
        },
        { once: true }
      );
    } else {
      initCopyEmail();
      initCopyrightYear();
      initEncryptedTextEffect();
      initFooterAnimation();
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.querySelector('.diziana-footer')) {
        initCopyEmail();
        initCopyrightYear();
        initEncryptedTextEffect();
        initFooterAnimation();
        if (window.ScrollTrigger) {
          requestAnimationFrame(() => {
            window.ScrollTrigger.refresh();
          });
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const menuItems = document.querySelectorAll('.header__menu-item--has-children');
    const dropdownLinks = document.querySelectorAll('.header__dropdown-link');
    const hamburger = document.querySelector('.header__hamburger');
    const drawer = document.getElementById('header-mobile-drawer');
    const overlay = document.getElementById('header-overlay');
    const drawerClose = document.querySelector('.header__drawer-close');
    const drawerItems = document.querySelectorAll('.header__drawer-item--has-children');

    dropdownLinks.forEach((link) => {
      if (link.querySelector('.header__dropdown-icon')) return;

      const icon = document.createElement('i');
      icon.className = 'ph-bold ph-caret-right header__dropdown-icon';
      icon.setAttribute('aria-hidden', 'true');

      const label = document.createElement('span');
      label.className = 'header__dropdown-label';

      while (link.firstChild) {
        label.appendChild(link.firstChild);
      }

      link.append(icon, label);
    });

    function closeAllDropdowns(openItem) {
      menuItems.forEach((item) => {
        if (item !== openItem) {
          item.classList.remove('header__menu-item--open');
          const trigger = item.querySelector('.header__menu-trigger');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        }
      });
    }

    menuItems.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        closeAllDropdowns(item);
        item.classList.add('header__menu-item--open');
        const trigger = item.querySelector('.header__menu-trigger');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
      });

      item.addEventListener('mouseleave', () => {
        item.classList.remove('header__menu-item--open');
        const trigger = item.querySelector('.header__menu-trigger');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    });

    function openDrawer() {
      if (!drawer || !overlay) return;
      drawer.classList.add('header__drawer--open');
      overlay.classList.add('header__overlay--visible');
      if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('drawer-open');
      const firstFocusable = drawer.querySelector('button, a[href], input, [tabindex]');
      if (firstFocusable) firstFocusable.focus();
    }

    function closeDrawer() {
      if (!drawer || !overlay) return;
      drawer.classList.remove('header__drawer--open');
      overlay.classList.remove('header__overlay--visible');
      if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('drawer-open');
      if (hamburger) hamburger.focus();
    }

    if (hamburger) {
      hamburger.addEventListener('click', () => {
        const isOpen = drawer.classList.contains('header__drawer--open');
        if (isOpen) {
          closeDrawer();
        } else {
          openDrawer();
        }
      });
    }

    if (drawerClose) {
      drawerClose.addEventListener('click', closeDrawer);
    }

    if (overlay) {
      overlay.addEventListener('click', closeDrawer);
    }

    function closeAllDrawerItems(openItem) {
      drawerItems.forEach((item) => {
        if (item !== openItem) {
          item.classList.remove('header__drawer-item--open');
          const trigger = item.querySelector('.header__drawer-trigger');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        }
      });
    }

    drawerItems.forEach((item) => {
      const trigger = item.querySelector('.header__drawer-trigger');
      if (!trigger) return;

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        const willOpen = !item.classList.contains('header__drawer-item--open');
        closeAllDrawerItems(item);
        item.classList.toggle('header__drawer-item--open', willOpen);
        trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });

    document.addEventListener('click', (event) => {
      const clickTarget = event.target;
      if (!(clickTarget instanceof Element)) return;
      if (clickTarget.closest('.header__menu') == null) {
        closeAllDropdowns(null);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        if (drawer && drawer.classList.contains('header__drawer--open')) {
          closeDrawer();
        } else {
          closeAllDropdowns(null);
        }
      }
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth >= 1200 && drawer && drawer.classList.contains('header__drawer--open')) {
        closeDrawer();
      }
    });

    const normalizePath = (path) => {
      if (!path) return '/';
      const normalized = path.replace(/\/+$/, '');
      return normalized === '' ? '/' : normalized;
    };

    document.addEventListener('click', (event) => {
      const clickTarget = event.target;
      if (!(clickTarget instanceof Element)) return;

      const link = clickTarget.closest('.header a[href*="/pages/services"], .header a[href*="/pages/plugins"], .header a[href*="/collections/premium-zendesk-themes"]');
      if (!(link instanceof HTMLAnchorElement)) return;

      const targetUrl = new URL(link.href, window.location.origin);
      const currentPath = normalizePath(window.location.pathname);
      const targetPath = normalizePath(targetUrl.pathname);

      if (currentPath !== targetPath) return;

      event.preventDefault();

      const requestedTab = targetUrl.searchParams.get('tab');
      const requestedScroll = targetUrl.searchParams.get('scroll');
      const validTabs = ['branding', 'byod', 'agentic-ai', 'consulting', 'upgrade'];
      let targetElement = null;

      if (requestedTab && validTabs.includes(requestedTab)) {
        const targetTabBtn = document.querySelector(`.services__tab-btn[data-tab="${requestedTab}"]`);
        if (targetTabBtn instanceof HTMLElement) {
          targetTabBtn.click();
        }
        targetElement = document.getElementById('services-tabs');
      } else if (requestedScroll) {
        targetElement = document.getElementById(requestedScroll);
      } else if (targetUrl.hash) {
        targetElement = document.getElementById(decodeURIComponent(targetUrl.hash.slice(1)));
      }

      if (!(targetElement instanceof HTMLElement)) return;

      history.replaceState(null, '', targetUrl.toString());
      targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });

      closeAllDropdowns(null);
      if (drawer && drawer.classList.contains('header__drawer--open')) {
        closeDrawer();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const init = () => {
      const section = document.querySelector('.home-hero');
      if (!section) {
        return;
      }

      if (window.gsap && !prefersReducedMotion) {
        const gsap = window.gsap;

        const tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

        tl.fromTo(
          section.querySelectorAll('.home-hero__line'),
          { y: 32, autoAlpha: 0 },
          { y: 0, autoAlpha: 1, duration: 0.8, stagger: 0.15 }
        )
          .fromTo(
            section.querySelector('.home-hero__subtitle'),
            { y: 24, autoAlpha: 0 },
            { y: 0, autoAlpha: 1, duration: 0.8 },
            '-=0.3'
          )
          .fromTo(
            section.querySelector('.home-hero__trusted-title'),
            { y: 20, autoAlpha: 0 },
            { y: 0, autoAlpha: 1, duration: 0.7 },
            '-=0.4'
          )
          .fromTo(
            section.querySelector('.home-hero__carousel'),
            { y: 20, autoAlpha: 0 },
            { y: 0, autoAlpha: 1, duration: 0.7 },
            '-=0.3'
          )
          .fromTo(
            section.querySelectorAll('.home-hero__cta'),
            { y: 16, autoAlpha: 0 },
            { y: 0, autoAlpha: 1, duration: 0.6, stagger: 0.1 },
            '-=0.3'
          );

        const carousel = section.querySelector('.home-hero__carousel-wrap');
        const tracks = carousel ? carousel.querySelectorAll('.home-hero__carousel-track') : [];

        if (tracks.length) {
          const gap = parseFloat(getComputedStyle(carousel).getPropertyValue('--brand-gap')) || 20;
          const singleTrackWidth = tracks[0].offsetWidth + gap;
          const pixelsPerSecond = 50;
          const duration = singleTrackWidth / pixelsPerSecond;

          const scrollTween = gsap.to(tracks, {
            x: -singleTrackWidth,
            duration: duration,
            ease: 'none',
            repeat: -1
          });

          carousel.addEventListener('mouseenter', () => scrollTween.pause());
          carousel.addEventListener('mouseleave', () => scrollTween.play());
        }
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["numbers"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const ensureNumberFlow = async () => {
      if (window.customElements && window.customElements.get('number-flow') && window.__themeNumberFlow?.continuous) {
        return window.__themeNumberFlow.continuous;
      }

      if (!window.__themeNumberFlowLoader) {
        window.__themeNumberFlowLoader = import('https://cdn.jsdelivr.net/npm/number-flow@0.6.0/+esm')
          .then((module) => {
            window.__themeNumberFlow = window.__themeNumberFlow || {};
            window.__themeNumberFlow.continuous = module.continuous;
            window.__themeNumberFlow.ready = true;
            return module.continuous;
          })
          .catch(() => null);
      }

      return window.__themeNumberFlowLoader;
    };

    const ensureScrollTriggerRegistered = () => {
      if (!window.gsap || !window.ScrollTrigger) {
        return false;
      }

      window.__themeGsap = window.__themeGsap || {};

      if (!window.__themeGsap.scrollTriggerRegistered) {
        window.gsap.registerPlugin(window.ScrollTrigger);
        window.__themeGsap.scrollTriggerRegistered = true;
      }

      return true;
    };
    const parseNumberFlowValue = (rawValue) => {
      const input = String(rawValue || '').trim();
      const match = input.match(/^([^0-9+-]*)([+-]?\d[\d,]*(?:\.\d+)?)([^0-9]*)$/);

      if (!match) {
        return null;
      }

      const numericPart = match[2].replace(/,/g, '');
      const numberValue = Number(numericPart);

      if (Number.isNaN(numberValue)) {
        return null;
      }

      const fractionPart = numericPart.split('.')[1] || '';

      return {
        value: numberValue,
        prefix: match[1],
        suffix: match[3],
        fractionDigits: fractionPart.length,
      };
    };

    const setupNumberFlow = (flowNode, parsedTarget, continuousPlugin) => {
      if (flowNode.dataset.numberFlowReady === 'true') {
        return false;
      }

      flowNode.dataset.numberFlowReady = 'true';
      flowNode.numberPrefix = parsedTarget.prefix;
      flowNode.numberSuffix = parsedTarget.suffix;
      flowNode.plugins = [continuousPlugin];
      flowNode.format = {
        useGrouping: false,
        minimumFractionDigits: parsedTarget.fractionDigits,
        maximumFractionDigits: parsedTarget.fractionDigits,
      };
      flowNode.update(0);
      return true;
    };

    const animateNumberFlows = async (flowNodes) => {
      const continuousPlugin = await ensureNumberFlow();

      if (!continuousPlugin) {
        return;
      }

      flowNodes.forEach((flowNode) => {
        const parsedTarget = parseNumberFlowValue(flowNode.dataset.numberFlowValue || flowNode.textContent);

        if (!parsedTarget) {
          return;
        }

        const isFirstInit = setupNumberFlow(flowNode, parsedTarget, continuousPlugin);

        if (isFirstInit) {
          requestAnimationFrame(() => {
            flowNode.update(parsedTarget.value);
          });
          return;
        }

        flowNode.update(parsedTarget.value);
      });
    };

    const initSection = (sectionNode) => {
      if (!sectionNode) {
        return;
      }

      if (sectionNode.dataset.numberFlowScrollReady === 'true') {
        return;
      }

      sectionNode.dataset.numberFlowScrollReady = 'true';

      const vectorPath = sectionNode.querySelector('.numbers__vector-path');
      if (vectorPath) {
        const animateVector = () => {
          const pathLength = vectorPath.getTotalLength();
          vectorPath.style.strokeDasharray = pathLength;
          vectorPath.style.strokeDashoffset = pathLength;
          vectorPath.classList.add('is-animated');
        };

        if (ensureScrollTriggerRegistered()) {
          window.ScrollTrigger.create({
            trigger: sectionNode,
            start: 'top 80%',
            once: true,
            onEnter: animateVector,
          });
        } else {
          animateVector();
        }
      }

      const flowNodes = Array.from(sectionNode.querySelectorAll('.js-number-flow'));

      if (!flowNodes.length) {
        return;
      }

      const startAllFlows = async () => {
        await animateNumberFlows(flowNodes);
      };

      if (!ensureScrollTriggerRegistered()) {
        startAllFlows();
        return;
      }

      window.ScrollTrigger.create({
        trigger: sectionNode,
        start: 'top 80%',
        once: true,
        onEnter: async () => {
          await startAllFlows();
        },
      });
    };

    const initSections = (scope) => {
      if (!scope) {
        return;
      }

      if (scope.matches && scope.matches('.numbers')) {
        initSection(scope);
      }

      scope.querySelectorAll('.numbers').forEach((sectionNode) => {
        initSection(sectionNode);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          initSections(document);
        },
        { once: true }
      );
    } else {
      initSections(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      initSections(event.target);

      if (window.ScrollTrigger) {
        requestAnimationFrame(() => {
          window.ScrollTrigger.refresh();
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plugins"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const scrollTargetId = new URLSearchParams(window.location.search).get('scroll');
    if (!scrollTargetId) return;

    const targetElement = document.getElementById(scrollTargetId);
    if (!(targetElement instanceof HTMLElement)) return;

    setTimeout(() => {
      targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 300);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["process"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const ensureScrollTriggerRegistered = () => {
      if (!window.gsap || !window.ScrollTrigger) return false;
      window.__themeGsap = window.__themeGsap || {};
      if (!window.__themeGsap.scrollTriggerRegistered) {
        window.gsap.registerPlugin(window.ScrollTrigger);
        window.__themeGsap.scrollTriggerRegistered = true;
      }
      return true;
    };

    const initProcessAnimations = () => {
      const processPage = document.querySelector('.process-page');
      if (!processPage || prefersReducedMotion || !ensureScrollTriggerRegistered()) return;

      const steps = document.querySelectorAll('.process-page__step');
      if (steps.length === 0) return;

      window.gsap.fromTo(
        steps,
        { y: 20, autoAlpha: 0 },
        {
          y: 0,
          autoAlpha: 1,
          duration: 0.5,
          ease: 'power2.out',
          stagger: 0.06,
          clearProps: 'transform,opacity,visibility',
          scrollTrigger: {
            trigger: processPage,
            start: 'top 75%',
            once: true,
            toggleActions: 'play none none none',
          },
        }
      );
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initProcessAnimations, { once: true });
    } else {
      initProcessAnimations();
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.querySelector('.process-page')) {
        initProcessAnimations();
        if (window.ScrollTrigger) {
          requestAnimationFrame(() => window.ScrollTrigger.refresh());
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    let currentIndex = 0;
    let allImages = [];
    let mainImageEl = null;
    let allThumbs = [];
    let thumbTrack = null;
    let thumbViewport = null;
    let originalImages = [];
    let originalThumbs = [];

    const initVariantSelect = () => {
      const select = document.getElementById('product-variant-select');
      if (!select) return;

      const priceEl = document.getElementById('product-current-price');
      const comparePriceEl = document.getElementById('product-compare-price');
      const mainImage = document.getElementById('product-main-image');

      const updateVariant = () => {
        const selected = select.options[select.selectedIndex];
        if (!selected) return;

        if (priceEl) {
          priceEl.textContent = selected.dataset.price;
        }

        if (comparePriceEl) {
          const compareAt = selected.dataset.compareAtPrice;
          if (compareAt) {
            comparePriceEl.textContent = compareAt;
            comparePriceEl.style.display = 'inline';
          } else {
            comparePriceEl.style.display = 'none';
          }
        }

        if (mainImage && selected.dataset.image) {
          mainImage.src = selected.dataset.image;
        }
      };

      select.addEventListener('change', updateVariant);
    };

    const updateMainImage = (index) => {
      if (index < 0 || index >= allImages.length || !mainImageEl) return;
      currentIndex = index;
      mainImageEl.src = allImages[index];

      const currentThumb = allThumbs[index];
      if (currentThumb) {
        const alt = currentThumb.getAttribute('aria-label') || '';
        mainImageEl.alt = alt;
        mainImageEl.dataset.alt = alt;
      }

      allThumbs.forEach((t) => t.classList.remove('product-premium__thumb--active'));
      if (allThumbs[index]) allThumbs[index].classList.add('product-premium__thumb--active');

      const prevBtn = document.querySelector('.js-product-thumb-prev');
      const nextBtn = document.querySelector('.js-product-thumb-next');
      if (prevBtn) prevBtn.disabled = currentIndex === 0;
      if (nextBtn) nextBtn.disabled = currentIndex === allImages.length - 1;
    };

    const getThumbScrollAmount = () => {
      if (!allThumbs.length) return 90;
      const gap = parseFloat(getComputedStyle(thumbTrack).gap) || 0;
      return allThumbs[0].offsetWidth + gap;
    };

    const initThumbArrows = () => {
      thumbViewport = document.querySelector('.js-product-thumb-viewport');
      thumbTrack = document.querySelector('.js-product-thumb-track');
      if (!thumbViewport || !thumbTrack) return;

      const prevBtn = document.querySelector('.js-product-thumb-prev');
      const nextBtn = document.querySelector('.js-product-thumb-next');

      const maxScroll = () => Math.max(0, thumbTrack.scrollWidth - thumbViewport.clientWidth);

      const getCurPos = () => {
        const mat = new DOMMatrix(getComputedStyle(thumbTrack).transform);
        return -mat.m41;
      };

      const setOffset = (x) => {
        const clamped = Math.max(0, Math.min(maxScroll(), x));
        thumbTrack.style.transform = `translateX(${-clamped}px)`;
      };

      const goToPrevImage = () => {
        if (currentIndex > 0) {
          updateMainImage(currentIndex - 1);
          scrollThumbToIndex(currentIndex);
        }
      };

      const goToNextImage = () => {
        if (currentIndex < allImages.length - 1) {
          updateMainImage(currentIndex + 1);
          scrollThumbToIndex(currentIndex);
        }
      };

      if (prevBtn) {
        prevBtn.addEventListener('click', goToPrevImage);
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', goToNextImage);
      }
    };

    const initProductGallery = () => {
      const section = document.querySelector('.product-premium');
      if (!section) return;

      mainImageEl = document.getElementById('product-main-image');
      if (!mainImageEl) return;

      allThumbs = Array.from(section.querySelectorAll('.product-premium__thumb'));
      if (!allThumbs.length) return;

      originalImages = allThumbs.map((thumb) => thumb.dataset.fullImage);
      originalThumbs = allThumbs.map((thumb) => ({
        fullImage: thumb.dataset.fullImage,
        alt: thumb.getAttribute('aria-label') || '',
        index: thumb.dataset.index,
        element: thumb
      }));

      allImages = [...originalImages];

      allThumbs.forEach((thumb, index) => {
        if (thumb.classList.contains('product-premium__thumb--active')) {
          currentIndex = index;
        }
        thumb.addEventListener('click', (e) => {
          e.preventDefault();
          updateMainImage(index);
          scrollThumbToIndex(index);
        });
      });

      initThumbArrows();

      const prevBtn = document.querySelector('.js-product-thumb-prev');
      const nextBtn = document.querySelector('.js-product-thumb-next');
      if (prevBtn) prevBtn.disabled = currentIndex === 0;
      if (nextBtn) nextBtn.disabled = currentIndex === allImages.length - 1;
    };

    const filterImagesByPalette = (paletteName) => {
      if (!mainImageEl || !thumbTrack || originalThumbs.length === 0) return;

      const filteredThumbs = originalThumbs.filter((thumb) => {
        if (!paletteName) return true;
        const alt = thumb.alt.toLowerCase();
        const name = paletteName.toLowerCase();
        return alt.includes(name);
      });

      if (filteredThumbs.length === 0) {
        allImages = [...originalImages];
        rebuildThumbnails(originalThumbs);
      } else {
        allImages = filteredThumbs.map((t) => t.fullImage);
        rebuildThumbnails(filteredThumbs);
      }

      currentIndex = 0;
      if (allImages.length > 0) {
        mainImageEl.src = allImages[0];
        const firstThumb = filteredThumbs.length > 0 ? filteredThumbs[0] : originalThumbs[0];
        if (firstThumb) {
          mainImageEl.alt = firstThumb.alt;
          mainImageEl.dataset.alt = firstThumb.alt;
        }
      }

      const prevBtn = document.querySelector('.js-product-thumb-prev');
      const nextBtn = document.querySelector('.js-product-thumb-next');
      if (prevBtn) prevBtn.disabled = currentIndex === 0;
      if (nextBtn) nextBtn.disabled = currentIndex === allImages.length - 1;

      if (window.gsap && mainImageEl) {
        window.gsap.fromTo(mainImageEl, { opacity: 0, scale: 0.98 }, { opacity: 1, scale: 1, duration: 0.3, ease: 'power2.out' });
      }
    };

    const rebuildThumbnails = (thumbs) => {
      thumbTrack.innerHTML = '';

      thumbs.forEach((thumbData, index) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'product-premium__thumb' + (index === 0 ? ' product-premium__thumb--active' : '');
        btn.dataset.index = index;
        btn.dataset.fullImage = thumbData.fullImage;
        btn.setAttribute('aria-label', thumbData.alt);

        const img = document.createElement('img');
        img.src = thumbData.fullImage.replace(/width:\s*\d+/, 'width: 150');
        img.alt = thumbData.alt;
        img.loading = 'lazy';
        btn.appendChild(img);

        btn.addEventListener('click', (e) => {
          e.preventDefault();
          updateMainImage(index);
          scrollThumbToIndex(index);
        });

        thumbTrack.appendChild(btn);
      });

      allThumbs = Array.from(thumbTrack.querySelectorAll('.product-premium__thumb'));
    };

    const initPaletteSelector = () => {
      const buttons = document.querySelectorAll('.product-premium__palette-btn');
      if (!buttons.length) return;

      const firstButton = buttons[0];
      if (firstButton) {
        buttons.forEach((b) => b.classList.remove('product-premium__palette-btn--active'));
        firstButton.classList.add('product-premium__palette-btn--active');
        filterImagesByPalette(firstButton.dataset.paletteName);
      }

      buttons.forEach((btn) => {
        btn.addEventListener('click', () => {
          const isActive = btn.classList.contains('product-premium__palette-btn--active');

          if (isActive) {
            return;
          }

          buttons.forEach((b) => b.classList.remove('product-premium__palette-btn--active'));
          btn.classList.add('product-premium__palette-btn--active');

          const paletteName = btn.dataset.paletteName;
          filterImagesByPalette(paletteName);
        });
      });
    };

    const handleKeydown = (e) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        const newIndex = currentIndex - 1;
        if (newIndex >= 0) {
          if (window.gsap && mainImageEl) {
            window.gsap.to(mainImageEl, {
              opacity: 0,
              duration: 0.2,
              onComplete: () => {
                updateMainImage(newIndex);
                scrollThumbToIndex(newIndex);
                window.gsap.to(mainImageEl, { opacity: 1, duration: 0.2 });
              }
            });
          } else {
            updateMainImage(newIndex);
            scrollThumbToIndex(newIndex);
          }
        }
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        const newIndex = currentIndex + 1;
        if (newIndex < allImages.length) {
          if (window.gsap && mainImageEl) {
            window.gsap.to(mainImageEl, {
              opacity: 0,
              duration: 0.2,
              onComplete: () => {
                updateMainImage(newIndex);
                scrollThumbToIndex(newIndex);
                window.gsap.to(mainImageEl, { opacity: 1, duration: 0.2 });
              }
            });
          } else {
            updateMainImage(newIndex);
            scrollThumbToIndex(newIndex);
          }
        }
      }
    };

    const scrollThumbToIndex = (index) => {
      if (!thumbTrack || !thumbViewport || !allThumbs[index]) return;
      const thumb = allThumbs[index];
      const thumbLeft = thumb.offsetLeft;
      const thumbWidth = thumb.offsetWidth;
      const viewportWidth = thumbViewport.clientWidth;
      const trackWidth = thumbTrack.scrollWidth;
      const maxScroll = trackWidth - viewportWidth;
      let target = thumbLeft - (viewportWidth / 2) + (thumbWidth / 2);
      target = Math.max(0, Math.min(maxScroll, target));
      if (window.gsap) {
        window.gsap.to(thumbTrack, { x: -target, duration: 0.45, ease: 'power2.inOut' });
      } else {
        thumbTrack.style.transform = `translateX(${-target}px)`;
      }
    };

    const initQuantitySelector = () => {
      const container = document.querySelector('.product-premium__quantity');
      if (!container) return;

      const input = container.querySelector('.product-premium__quantity-input');
      const minusBtn = container.querySelector('.product-premium__quantity-btn--minus');
      const plusBtn = container.querySelector('.product-premium__quantity-btn--plus');

      if (!input || !minusBtn || !plusBtn) return;

      minusBtn.addEventListener('click', () => {
        const current = parseInt(input.value) || 1;
        if (current > 1) {
          input.value = current - 1;
        }
      });

      plusBtn.addEventListener('click', () => {
        const current = parseInt(input.value) || 1;
        const max = parseInt(input.max) || 10;
        if (current < max) {
          input.value = current + 1;
        }
      });
    };

    const initPreviewButton = () => {
      const desc = document.querySelector('.product-premium__description');
      if (!desc) return;

      const links = desc.querySelectorAll('a');
      links.forEach((link) => {
        const text = link.textContent.trim();
        if (text.includes('Live Preview') || text.includes('Live preview')) {
          link.classList.add('product-premium__preview-btn');
          if (!link.querySelector('i')) {
            const icon = document.createElement('i');
            icon.className = 'ph-bold ph-browsers';
            link.prepend(icon);
          }
          const parent = link.parentElement;
          if (parent && (parent.tagName === 'H4' || parent.tagName === 'H3')) {
            parent.replaceWith(link);
          }
        }
      });
    };

    const initScrollReveal = () => {
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReducedMotion) return;

      const cards = document.querySelectorAll('.product-premium__similar-card');
      if (!window.IntersectionObserver || cards.length === 0) return;

      cards.forEach((card) => {
        card.style.opacity = '0';
        card.style.transform = 'translateY(16px)';
        card.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      });

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.style.opacity = '1';
              entry.target.style.transform = 'translateY(0)';
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1, rootMargin: '0px 0px -20px 0px' }
      );

      cards.forEach((card) => observer.observe(card));
    };

    const initBuyNowButton = () => {
      const buyNowBtn = document.querySelector('.product-premium__buy-now');
      if (!buyNowBtn) return;

      buyNowBtn.addEventListener('click', () => {
        const form = document.getElementById('product-form');
        if (!form) return;

        const variantSelect = document.getElementById('product-variant-select');
        const variantId = variantSelect ? variantSelect.value : form.querySelector('input[name="id"]')?.value;
        const quantityInput = document.querySelector('.product-premium__quantity-input');
        const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

        if (!variantId) return;

        window.location.href = `/cart/${variantId}:${quantity}`;
      });
    };

    const runInit = () => {
      initProductGallery();
      initVariantSelect();
      initQuantitySelector();
      initPreviewButton();
      initScrollReveal();
      initBuyNowButton();
      initPaletteSelector();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runInit, { once: true });
    } else {
      runInit();
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.querySelector('.product-premium')) {
        initProductGallery();
        initVariantSelect();
        initPreviewButton();
        initScrollReveal();
        initPaletteSelector();
      }
    });

    document.addEventListener('keydown', handleKeydown);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSection = (sectionNode) => {
      if (!sectionNode) {
        return;
      }

      if (sectionNode.dataset.promoVectorReady === 'true') {
        return;
      }

      sectionNode.dataset.promoVectorReady = 'true';

      const vectorPath = sectionNode.querySelector('.promo__vector-path');
      if (!vectorPath) {
        return;
      }

      const animateVector = () => {
        const pathLength = vectorPath.getTotalLength();
        vectorPath.style.strokeDasharray = pathLength;
        vectorPath.style.strokeDashoffset = pathLength;
        vectorPath.classList.add('is-animated');
      };

      if (window.gsap && window.ScrollTrigger) {
        if (!window.__themeGsap || !window.__themeGsap.scrollTriggerRegistered) {
          window.gsap.registerPlugin(window.ScrollTrigger);
          window.__themeGsap = window.__themeGsap || {};
          window.__themeGsap.scrollTriggerRegistered = true;
        }

        window.ScrollTrigger.create({
          trigger: sectionNode,
          start: 'top 80%',
          once: true,
          onEnter: animateVector,
        });
      } else {
        animateVector();
      }
    };

    const initSections = (scope) => {
      if (!scope) {
        return;
      }

      if (scope.matches && scope.matches('.promo')) {
        initSection(scope);
      }

      scope.querySelectorAll('.promo').forEach((sectionNode) => {
        initSection(sectionNode);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          initSections(document);
        },
        { once: true }
      );
    } else {
      initSections(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      initSections(event.target);

      if (window.ScrollTrigger) {
        requestAnimationFrame(() => {
          window.ScrollTrigger.refresh();
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["services"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const initializedSections = new WeakSet();

    const initTabs = (section) => {
      const tabBtns = section.querySelectorAll('.services__tab-btn');
      const tabPanels = section.querySelectorAll('.services__tab-panel');
      const tabsSection = section.querySelector('.services__tabs');

      const validTabs = ['branding', 'byod', 'agentic-ai', 'consulting', 'upgrade'];

      const getRequestedTab = () => {
        const params = new URLSearchParams(window.location.search);
        const queryTab = params.get('tab');

        if (queryTab && validTabs.includes(queryTab)) {
          return queryTab;
        }

        const hash = window.location.hash.replace('#', '');
        if (hash && validTabs.includes(hash)) {
          return hash;
        }

        return '';
      };

      const activateTab = (tabValue, updateHash = true) => {
        tabBtns.forEach((b) => {
          b.classList.remove('active');
          b.setAttribute('aria-selected', 'false');
        });
        tabPanels.forEach((p) => p.classList.remove('active'));

        const targetBtn = section.querySelector(`.services__tab-btn[data-tab="${tabValue}"]`);
        if (targetBtn) {
          targetBtn.classList.add('active');
          targetBtn.setAttribute('aria-selected', 'true');
        }

        const targetPanel = section.querySelector(`.services__tab-panel[data-panel="${tabValue}"]`);
        if (targetPanel) {
          targetPanel.classList.add('active');
        }

        section.querySelectorAll('[data-tab-extra]').forEach((block) => {
          if (block.dataset.tabExtra === tabValue) {
            block.removeAttribute('hidden');
            block.setAttribute('aria-hidden', 'false');
          } else {
            block.setAttribute('hidden', '');
            block.setAttribute('aria-hidden', 'true');
          }
        });

        if (updateHash && validTabs.includes(tabValue)) {
          const url = new URL(window.location.href);
          url.searchParams.set('tab', tabValue);
          url.hash = 'services-tabs';
          history.replaceState(null, '', url.toString());
        }
      };

      tabBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          activateTab(btn.dataset.tab);
        });
      });

      window.addEventListener('hashchange', () => {
        const requestedTab = getRequestedTab();
        if (requestedTab) {
          if (tabsSection) {
            tabsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
          activateTab(requestedTab, false);
        }
      });

      const requestedTab = getRequestedTab();
      if (requestedTab) {
        setTimeout(() => {
          if (tabsSection) {
            tabsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
          activateTab(requestedTab, false);
        }, 300);
      } else {
        activateTab('branding', false);
      }
    };

    const initFaq = (section) => {
      const faqItems = section.querySelectorAll('.services__faq-item');

      faqItems.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (item.open) {
            faqItems.forEach((other) => {
              if (other !== item) {
                other.removeAttribute('open');
              }
            });
          }
        });
      });
    };

    const initOverview = (section) => {
      const overviewItems = section.querySelectorAll('.services__overview-item');

      overviewItems.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (item.open) {
            overviewItems.forEach((other) => {
              if (other !== item) {
                other.removeAttribute('open');
              }
            });
          }
        });
      });
    };

    const initTierSelectors = (section) => {
      const tierSelectors = section.querySelectorAll('.services__tier-select');

      tierSelectors.forEach((select) => {
        select.addEventListener('change', () => {
          const selectedOption = select.options[select.selectedIndex];
          const variantUrl = selectedOption.dataset.url;
          const wrapper = select.closest('.services__tier-selector');
          const buyNowBtn = wrapper?.parentElement?.querySelector('[data-buy-now]');

          if (buyNowBtn && variantUrl) {
            buyNowBtn.href = variantUrl;
          }
        });
      });
    };

    const init = () => {
      document.querySelectorAll('.services').forEach((section) => {
        if (initializedSections.has(section)) return;
        initializedSections.add(section);

        initTabs(section);
        initFaq(section);
        initOverview(section);
        initTierSelectors(section);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target;
      if (section.querySelector('.services__tabs-nav')) {
        initTabs(section);
      }
      if (section.querySelector('.services__faq')) {
        initFaq(section);
      }
      if (section.querySelector('.services__overview')) {
        initOverview(section);
      }
      if (section.querySelector('.services__tier-select')) {
        initTierSelectors(section);
      }

      if (window.ScrollTrigger) {
        requestAnimationFrame(() => {
          window.ScrollTrigger.refresh();
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const viewportData = new WeakMap();

    const getClientX = (e) => e.touches ? e.touches[0].clientX : e.clientX;

    const initViewport = (viewport) => {
      if (!viewport || viewportData.has(viewport)) return;

      const track = viewport.querySelector('.js-testimonials-track');
      if (!track) return;

      const controls = viewport.parentElement.querySelector('.js-testimonials-controls');
      const prevBtn = controls?.querySelector('.js-testimonials-prev');
      const nextBtn = controls?.querySelector('.js-testimonials-next');

      let isDragging = false;
      let startX = 0;
      let scrollLeft = 0;
      let velX = 0;
      let lastX = 0;
      let lastTime = 0;
      let rafId = null;
      let resizeObserver = null;

      const maxScroll = () => Math.max(0, track.scrollWidth - viewport.clientWidth);

      const getCurPos = () => {
        const mat = new DOMMatrix(getComputedStyle(track).transform);
        return -mat.m41;
      };

      const updateButtonStates = () => {
        const pos = getCurPos();
        const max = maxScroll();
        if (prevBtn) prevBtn.disabled = pos <= 0;
        if (nextBtn) nextBtn.disabled = pos >= max;
      };

      const setOffset = (x) => {
        const clamped = Math.max(0, Math.min(maxScroll(), x));
        track.style.transform = `translateX(${-clamped}px)`;
        updateButtonStates();
        return clamped;
      };

      const getCardScrollAmount = () => {
        const card = track.querySelector('.js-testimonials-card');
        if (!card) return 300;
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        return card.offsetWidth + gap;
      };

      const startDrag = (e) => {
        if (e.target.closest('button')) return;
        isDragging = true;
        viewport.classList.add('is-dragging');
        startX = getClientX(e);
        lastX = startX;
        lastTime = performance.now();
        velX = 0;
        const mat = new DOMMatrix(getComputedStyle(track).transform);
        scrollLeft = -mat.m41;
        if (rafId) cancelAnimationFrame(rafId);
      };

      const onDrag = (e) => {
        if (!isDragging) return;
        if (e.cancelable) e.preventDefault();
        const x = getClientX(e);
        const now = performance.now();
        const dt = Math.max(now - lastTime, 1);
        const delta = (lastX - x) * 0.55;
        velX = (x - lastX) / dt;
        lastX = x;
        lastTime = now;
        scrollLeft = setOffset(scrollLeft + delta);
      };

      const endDrag = () => {
        if (!isDragging) return;
        isDragging = false;
        viewport.classList.remove('is-dragging');
        const mat = new DOMMatrix(getComputedStyle(track).transform);
        let pos = -mat.m41;
        let v = -velX * 50;
        const friction = 0.80;

        const glide = () => {
          v *= friction;
          pos += v;
          pos = setOffset(pos);
          if (Math.abs(v) > 0.3 && pos > 0 && pos < maxScroll()) {
            rafId = requestAnimationFrame(glide);
          }
        };
        rafId = requestAnimationFrame(glide);
      };

      viewport.addEventListener('mousedown', startDrag);
      viewport.addEventListener('touchstart', startDrag, { passive: true });
      window.addEventListener('mousemove', onDrag);
      window.addEventListener('touchmove', onDrag, { passive: false });
      window.addEventListener('mouseup', endDrag);
      window.addEventListener('touchend', endDrag);

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          let pos = getCurPos();
          const target = Math.max(0, pos - getCardScrollAmount());
          if (window.gsap) {
            window.gsap.to(track, { x: -target, duration: 0.45, ease: 'power2.inOut', onUpdate: updateButtonStates, onComplete: updateButtonStates });
          } else {
            setOffset(target);
          }
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          let pos = getCurPos();
          const target = Math.min(maxScroll(), pos + getCardScrollAmount());
          if (window.gsap) {
            window.gsap.to(track, { x: -target, duration: 0.45, ease: 'power2.inOut', onUpdate: updateButtonStates, onComplete: updateButtonStates });
          } else {
            setOffset(target);
          }
        });
      }

      updateButtonStates();

      if (typeof ResizeObserver !== 'undefined') {
        resizeObserver = new ResizeObserver(() => {
          const mat = new DOMMatrix(getComputedStyle(track).transform);
          let pos = -mat.m41;
          setOffset(Math.min(pos, maxScroll()));
        });
        resizeObserver.observe(viewport);
      }

      viewportData.set(viewport, {
        resizeObserver,
        destroy() {
          if (resizeObserver) resizeObserver.disconnect();
          if (rafId) cancelAnimationFrame(rafId);
          track.style.transform = '';
        }
      });
    };

    const initSections = (scope) => {
      if (!scope) return;
      if (scope.matches && scope.matches('.testimonials')) {
        scope.querySelectorAll('.js-testimonials-viewport').forEach(initViewport);
      }
      scope.querySelectorAll('.testimonials').forEach((sectionNode) => {
        sectionNode.querySelectorAll('.js-testimonials-viewport').forEach(initViewport);
      });
    };

    const runInit = () => { initSections(document); };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runInit, { once: true });
    } else {
      runInit();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initSections(event.target);
      if (window.ScrollTrigger) {
        requestAnimationFrame(() => { window.ScrollTrigger.refresh(); });
      }
    });

    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('.js-testimonials-viewport').forEach((viewport) => {
        const data = viewportData.get(viewport);
        if (data && data.destroy) data.destroy();
        viewportData.delete(viewport);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theme-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const initializedSections = new WeakSet();

    const ensureGSAPReady = () => {
      if (!window.gsap) return false;
      if (!window.__themeGsap) window.__themeGsap = {};
      if (!window.__themeGsap.scrollTriggerRegistered) {
        window.gsap.registerPlugin(window.ScrollTrigger);
        window.__themeGsap.scrollTriggerRegistered = true;
      }
      return true;
    };

    const initHoverScroll = (sectionNode) => {
      const scrollContainers = sectionNode.querySelectorAll('[data-scroll-image]');

      scrollContainers.forEach((container) => {
        const img = container.querySelector('.theme-section__image');
        if (!img) return;

        let scrollTween = null;
        const speed = 1.2;

        container.addEventListener('mouseenter', () => {
          const parent = container.parentElement;
          const containerH = parent.clientHeight;
          const imgH = img.clientHeight;

          if (imgH <= containerH) return;

          const maxScroll = imgH - containerH;
          const duration = maxScroll / (speed * 100);

          scrollTween = window.gsap.to(container, {
            y: -maxScroll,
            duration: duration,
            ease: 'none',
            overwrite: true,
          });
        });

        container.addEventListener('mouseleave', () => {
          if (scrollTween) {
            scrollTween.kill();
            scrollTween = null;
          }

          window.gsap.to(container, {
            y: 0,
            duration: 0.9,
            ease: 'power2.out',
            overwrite: true,
          });
        });
      });
    };

    const initScrollTriggerReveal = (sectionNode) => {
      if (prefersReducedMotion || !ensureGSAPReady()) return;

      const headerNode = sectionNode.querySelector('.theme-section__header');
      const boxNode = sectionNode.querySelector('.theme-section__box');
      const tickerNodes = sectionNode.querySelectorAll('.theme-section__ticker');

      if (!headerNode || !boxNode) return;

      window.gsap.set([headerNode, boxNode], {
        y: 28,
        autoAlpha: 0,
      });

      if (tickerNodes.length) {
        window.gsap.set(tickerNodes, {
          y: 20,
          autoAlpha: 0,
        });
      }

      const vectorPath = sectionNode.querySelector('.theme-section__zendesk-vector-path');
      if (vectorPath) {
        window.gsap.set(vectorPath, {
          strokeDasharray: vectorPath.getTotalLength(),
          strokeDashoffset: vectorPath.getTotalLength(),
        });
      }

      const timeline = window.gsap.timeline({
        scrollTrigger: {
          trigger: sectionNode,
          start: 'top 78%',
          once: true,
          toggleActions: 'play none none none',
        },
      });

      timeline.to(headerNode, {
        y: 0,
        autoAlpha: 1,
        duration: 0.92,
        ease: 'power3.out',
        clearProps: 'transform,opacity,visibility',
      });

      timeline.to(
        boxNode,
        {
          y: 0,
          autoAlpha: 1,
          duration: 0.92,
          ease: 'power3.out',
          clearProps: 'transform,opacity,visibility',
        },
        '<0.32'
      );

      if (vectorPath) {
        timeline.add(() => {
          vectorPath.classList.add('is-animated');
        }, '<0.32');
      }

      if (tickerNodes.length) {
        timeline.to(
          tickerNodes[0],
          {
            y: 0,
            autoAlpha: 1,
            duration: 0.72,
            ease: 'power3.out',
            clearProps: 'transform,opacity,visibility',
          },
          '<0.28'
        );

        if (tickerNodes[1]) {
          timeline.to(
            tickerNodes[1],
            {
              y: 0,
              autoAlpha: 1,
              duration: 0.72,
              ease: 'power3.out',
              clearProps: 'transform,opacity,visibility',
            },
            '<0.18'
          );
        }
      }
    };

    const initSection = (sectionNode) => {
      if (!sectionNode || initializedSections.has(sectionNode)) return;
      initializedSections.add(sectionNode);

      initHoverScroll(sectionNode);
      initScrollTriggerReveal(sectionNode);
      initTicker(sectionNode);
    };

    const initTicker = (sectionNode) => {
      if (prefersReducedMotion) return;
      if (!window.gsap) return;

      const tickers = sectionNode.querySelectorAll('.theme-section__ticker');

      tickers.forEach(function (ticker) {
        const tracks = ticker.querySelectorAll('.theme-section__ticker-track');
        if (!tracks.length) return;

        const track = tracks[0];
        const gap = parseFloat(getComputedStyle(track).gap) || 56;
        const singleTrackWidth = track.offsetWidth + gap;

        if (singleTrackWidth <= 0) return;

        const isReverse = ticker.classList.contains('theme-section__ticker--reverse');
        const pixelsPerSecond = 40;
        const duration = singleTrackWidth / pixelsPerSecond;

        let scrollTween;
        if (isReverse) {
          window.gsap.set(tracks, { x: -singleTrackWidth });
          scrollTween = window.gsap.to(tracks, {
            x: 0,
            duration: duration,
            ease: 'none',
            repeat: -1,
            overwrite: true,
          });
        } else {
          scrollTween = window.gsap.to(tracks, {
            x: -singleTrackWidth,
            duration: duration,
            ease: 'none',
            repeat: -1,
          });
        }

        ticker.addEventListener('mouseenter', function () {
          scrollTween.pause();
        });

        ticker.addEventListener('mouseleave', function () {
          scrollTween.play();
        });
      });
    };

    const initSections = (scope) => {
      if (!scope) return;
      if (scope.matches && scope.matches('.theme-section')) {
        initSection(scope);
      }
      scope.querySelectorAll('.theme-section').forEach(initSection);
    };

    const runInit = () => initSections(document);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runInit, { once: true });
    } else {
      runInit();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initSections(event.target);
      if (window.ScrollTrigger) {
        requestAnimationFrame(() => window.ScrollTrigger.refresh());
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
